// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M2 2H22V11H17.4458L15.425 14.2333L9.5598 6.41307L5.54623 11H2V2Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M2 13V22H22V13H18.5542L15.575 17.7667L9.4402 9.58693L6.45377 13H2Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-activity-filled')
export default class ActivityFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'activity-filled',
    }
  }
}
